import ky from "ky-universal";
// This is a polyfill for AbortController to support IE
if (typeof window !== "undefined" &&
    typeof window.AbortController === "undefined") {
    require("abortcontroller-polyfill/dist/polyfill-patch-fetch");
}
export const controller = new AbortController();
const { signal } = controller;
const APICache = {
    API: ky.extend({
        signal,
        hooks: {
            beforeRequest: [
                (request) => {
                    request.headers.set("GoCardless-Version", "2015-07-06");
                    request.headers.set("Accept", "application/json");
                    if (APICache.accessToken) {
                        request.headers.set("authorization", `Bearer ${APICache.accessToken}`);
                    }
                },
            ],
        },
        retry: {
            limit: 0,
        },
    }),
};
export const extendAPI = (options) => {
    APICache.API = APICache.API.extend(options);
};
export const addAccessToken = (accessToken) => {
    APICache.accessToken = accessToken;
};
export const addPrefixUrl = (prefixUrl) => {
    extendAPI({
        prefixUrl: prefixUrl,
    });
};
export default APICache;
